module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_2.7b0964c5.woff2";